<template>
  <div class="ai-generate-credit-display d-flex align-items-center gap-gd-1">
    <b-skeleton-wrapper :loading="isLoadingAiCredit" :row="1" :col="1">
      <template #loading>
        <b-skeleton height="16px" width="190px"></b-skeleton>
      </template>
      <template #default>
        <span class="fs-sa-12 flh-1">
          <img :src="require('@assets/images/icon/ai_generate_small.svg')" style="width: 12px; height: 12px">
        </span>
        <div class="credit-amount fs-sa-12 d-flex gap-gd-half">
          <span class="amount fw-400">{{ $helper.numeric.formatAbbreviate(creditAvailable) }}</span>
          <span class="unit text-makeweb-ai-gradient-2 fw-700">Credits</span>
        </div>
        <div class="credit-separator bg-gray-light"></div>
        <div class="usage-amount fs-sa-12 fw-400 d-flex align-items-center gap-gd-half">
          <span :class="usedThisTimeLabelClass">{{ $t('engine.aiGenerate.lblUsedThisTime', languageEngine) }}</span>
          <span class="amount text-danger">{{ $helper.numeric.formatComma(responseMsgAssistant) }}</span>
        </div>
      </template>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AIGenerateCreditDisplay',
  props: {
    usedThisTimeLabelClass: {
      type: String,
      default: 'text-default'
    },
    msgAssistant: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine',
      creditDetailAI: 'designIframe/credit/creditDetailAI',
      isLoadingAiCredit: 'designIframe/credit/isLoadingAiCredit'
    }),
    creditAvailable() {
      return this.creditDetailAI.available;
    },
    creditRemaining() {
      return this.creditDetailAI.creditRemaining;
    },
    responseMsgAssistant() {
      const count = 1
      return Math.max(0, count);
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-generate-credit-display{
  .credit-separator {
    width: 1px;
    height: 14px;
  }
}

</style>
